import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { UtilService } from '../services/util.service';

const VALID_ROLES = ['admin', 'super admin', 'executive', 'manager', 'support'];

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const utilService = inject(UtilService);

  const user = authService.getUser();
  if (!user) {
    utilService.navigate('/');
    return false;
  }

  const skipMfa = route.data?.['skipMfaCheck'];
  if (!skipMfa && user.isMfaEnabled && user.mfaVerified !== true) {
    utilService.navigate('/mfa-login');
    return false;
  }

  const requiredRoles = route.data?.['roles'] as string[] | undefined;
  if (requiredRoles) {
    const userRole = (user.role || '').toLowerCase();
    const hasRole = requiredRoles.some(r => r.toLowerCase() === userRole);
    if (!hasRole) {
      utilService.navigate('/app/dashboard');
      return false;
    }
  }

  return true;
};
